export default [
  {
    path: '/settle/:fid',
    name: 'Settle',
    component: () => import('@/views/Settle'),
    meta: {
      roles: ['distributor', 'customer'],
    },
    children: [
      {
        path: 'addressList',
        name: 'SettleAddressList',
        component: () => import('@/views/Settle/addressList'),
        meta: {
          roles: ['distributor', 'customer'],
        },

        children: [
          {
            path: 'addressAdd',
            name: 'SettleAddressAdd',
            component: () => import('@/views/Settle/addressAdd'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
        ],
      },
      {
        path: 'needInvoice',
        name: 'NeedInvoice',
        component: () => import('@/views/Settle/needInvoice'),
        meta: {
          roles: ['distributor', 'customer'],
        },
        children: [
          {
            path: 'addressList',
            name: 'NeedInvoiceAddressList',
            component: () => import('@/views/Settle/addressListSimple'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
        ],
      },
      {
        path: 'payPwd',
        name: 'SettleSafePayPwd',
        component: () => import('@/views/Setting/Safe/payPwd'),
        meta: {
          roles: ['distributor', 'customer'],
        },
        children: [
          {
            path: 'code',
            name: 'SettleSafePayPwdCode',
            component: () => import('@/views/Setting/Safe/code'),
            meta: {
              roles: ['distributor', 'customer'],
            },
          },
        ],
      },
    ],
  },
]
